import { Component, ElementRef, OnInit, ViewChild, Input } from '@angular/core';

let tooltipCounter = 0;

@Component({
  selector: 'app-tooltip',
  templateUrl: './tooltip.component.html',
  styleUrls: ['./tooltip.component.scss']
})
export class TooltipComponent implements OnInit {
  @Input() content: string = ''
  @Input() position: ('bottom' |'left' | 'right' | 'top') = 'bottom'
  @ViewChild('tooltip', {static:true})tooltip: ElementRef
  isHover: boolean = false
  tooltipId = `tooltip-${++tooltipCounter}`

  constructor() { }

  ngOnInit(): void {
    if(!this.position){
      this.position = 'bottom'
    }
  }
  leave(event){
    this.isHover = false
  }
  enter(event){
    this.isHover = true
  }

}
